module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-05.a08838b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-05.jpg
// module id = fYKl
// module chunks = 1